var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondashboardkitchen = function SvgIcondashboardkitchen(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Notifications/icon.dashboard.kitchen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Notifications/icon.dashboard.kitchen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0.987463752 L42,0.987463752 C43.6990005,1.62798142 44.8422667,2.2658422 45.4297985,2.90104612 C46.0173303,3.53625003 46.5407308,4.70028865 47,6.39316196 L47,54.1226568 C46.512321,55.9451119 45.9889205,57.1849547 45.4297985,57.842185 C44.8706765,58.4994154 43.7274103,59.218687 42,60 L20,60 C18.4342577,59.2551896 17.3562987,58.5359179 16.7661232,57.842185 C16.1759476,57.1484522 15.5872399,55.9086094 15,54.1226568 L15,6.39316196 C15.5848977,4.70567911 16.1736055,3.54164049 16.7661232,2.90104612 C17.3586409,2.26045175 18.4365998,1.62259096 20,0.987463752 Z",
    id: "BG",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,0 C44.8659932,0 48,3.13400675 48,7 L48,54 C48,57.1706393 45.8919961,59.8489278 43.0010432,60.7098107 L43,61 C43,61.5522847 42.5522847,62 42,62 C41.4477153,62 41,61.5522847 41,61 L21,61 C21,61.5522847 20.5522847,62 20,62 C19.4477153,62 19,61.5522847 19,61 L18.9999537,60.7101075 C16.1084885,59.8495435 14,57.1710037 14,54 L14,7 C14,3.13400675 17.1340068,0 21,0 L41,0 Z M46,26 L16,26 L16,54 C16,56.6887547 18.1223067,58.8818181 20.7831104,58.9953805 L21,59 L41,59 C43.6887547,59 45.8818181,56.8776933 45.9953805,54.2168896 L46,54 L46,26 Z M42,30 C42.5522847,30 43,30.4477153 43,31 L43,41 C43,41.5522847 42.5522847,42 42,42 C41.4477153,42 41,41.5522847 41,41 L41,31 C41,30.4477153 41.4477153,30 42,30 Z M41,2 L21,2 C18.3112453,2 16.1181819,4.12230671 16.0046195,6.78311038 L16,7 L16,24 L46,24 L46,7 C46,4.3112453 43.8776933,2.11818189 41.2168896,2.00461951 L41,2 Z M42,13 C42.5522847,13 43,13.4477153 43,14 L43,19 C43,19.5522847 42.5522847,20 42,20 C41.4477153,20 41,19.5522847 41,19 L41,14 C41,13.4477153 41.4477153,13 42,13 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondashboardkitchen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.dashboard.kitchen.e4f3f88258b626f407ca56754e2089b3.svg";